// @flow

import * as React from 'react';
import CONST from 'app/common/lib/Const';
import ImpressionTracker from 'app/common/lib/react/ImpressionTracker';
import ProfileBoardCard from 'app/common/react/components/profile/ProfileBoardCard/ProfileBoardCard';
import type { Invite } from 'app/common/react/components/BoardCollab/types';
import type { ProfileBoardCardLayout } from 'app/common/react/components/profile/ProfileBoardCard/layout';
import type {
  ImageType,
  ImagePositionType,
  ProfileBoardType,
} from 'app/common/react/components/profile/ProfileBoardCard/commonTypes';

type Props = {
  board: ProfileBoardType,
  canEdit: boolean,
  coverImagePos: ImagePositionType,
  coverImageUrl: string,
  images: {
    '170x': ?Array<ImageType>,
  },
  invite?: Invite,
  isOwnProfile: boolean,
  isReordering?: boolean,
  isUserBlocked?: boolean,
  layout: 'list' | ProfileBoardCardLayout,
  onDeclineRequest?: () => void,
  onEditClick: (event: SyntheticMouseEvent<>) => void,
  progress: ?number,
  slotIndex: number,
  subtitle: ?React.Element<any>,
  toastImageUrl: string,
};

export default function ProfileBoardCardWithImpressions(props: Props) {
  const { board, isOwnProfile, slotIndex } = props;
  const viewParameter = isOwnProfile
    ? PCONST.thrift.ViewParameterType.BOARD_SELF
    : PCONST.thrift.ViewParameterType.BOARD_OTHERS;

  return (
    <ImpressionTracker
      componentType={PCONST.thrift.ComponentType.USER_BOARDS}
      loggingId={board.id}
      impressionType="Board"
      slotIndex={slotIndex}
      viewType={PCONST.thrift.ViewType.USER}
      viewParameter={viewParameter}
    >
      <ProfileBoardCard {...props} showSecretIcon={board.privacy === CONST.BoardPrivacy.SECRET} />
    </ImpressionTracker>
  );
}
